<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Nuevo Contrato')">
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px;"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <br />
        <el-row :gutter="20" v-if="!loading">
          <el-col :md="12">
            <h2>{{ $t('Flujos de Revisión.') }}</h2>
          </el-col>
          <el-col :md="12">
            <StepsContrato v-bind:step="1"></StepsContrato>
          </el-col>
        </el-row>
        <br><br>
        <!-- Workflow Salud -->
        <el-row :gutter="20" v-if="!loading">
          <el-col :md="6">
            <div>
              <span>{{ $t('Flujo de revisión Riesgos de Salud') }}</span><br><br>
              <el-select size="small" v-model="selectedWorkflows.salud" @change="setAuxSelectedWorkflows('salud')"
                filterable :placeholder="$t('Seleccione un flujo de revisión')" class="w-90">
                <el-option v-for="workflow in workflows" :label="workflow.name" :value="workflow._id"
                  :key="workflow._id" />
              </el-select>
            </div>
          </el-col>

          <el-col v-if="auxSelectedWorkflows.salud" :md="18" class="worflow-preview">
            <span>{{ $t('Previsualización') }} "{{ auxSelectedWorkflows.salud.name }}"</span><br><br>
            <Workflow :workflow="auxSelectedWorkflows.salud"></Workflow>
          </el-col>
        </el-row>

        <hr class="separator" v-if="!loading" />

        <!-- Workflow Seguridad -->
        <el-row :gutter="20" v-if="!loading">
          <el-col :md="6">
            <div>
              <span>{{ $t('Flujo de revisión Riesgos de Seguridad') }}</span><br><br>
              <el-select size="small" v-model="selectedWorkflows.seguridad"
                @change="setAuxSelectedWorkflows('seguridad')" filterable
                :placeholder="$t('Seleccione un flujo de revisión')" class="w-90">
                <el-option v-for="workflow in workflows" :label="workflow.name" :value="workflow._id"
                  :key="workflow._id" />
              </el-select>
            </div>
          </el-col>

          <el-col v-if="auxSelectedWorkflows.seguridad" :md="18" class="worflow-preview">
            <span>{{ $t('Previsualización') }} "{{ auxSelectedWorkflows.seguridad.name }}"</span><br><br>
            <Workflow :workflow="auxSelectedWorkflows.seguridad"></Workflow>
          </el-col>
        </el-row>

        <hr class="separator" v-if="!loading" />

        <!-- Workflow Salud -->
        <el-row :gutter="20" v-if="!loading">
          <el-col :md="6">
            <div>
              <span>{{ $t('Flujo de revisión Riesgos de Medioambiente') }}</span><br><br>
              <el-select size="small" v-model="selectedWorkflows.medioambiente"
                @change="setAuxSelectedWorkflows('medioambiente')" filterable
                :placeholder="$t('Seleccione un flujo de revisión')" class="w-90">
                <el-option v-for="workflow in workflows" :label="workflow.name" :value="workflow._id"
                  :key="workflow._id" />
              </el-select>
            </div>
          </el-col>

          <el-col v-if="auxSelectedWorkflows.medioambiente" :md="18" class="worflow-preview">
            <span>{{ $t('Previsualización') }} "{{ auxSelectedWorkflows.medioambiente.name }}"</span><br><br>
            <Workflow :workflow="auxSelectedWorkflows.medioambiente"></Workflow>
          </el-col>
        </el-row>
        <hr class="separator" v-if="!loading"/>
        <el-row>
          <el-col :span="24" class="centrar">
            <el-button-group>
              <el-button type="primary" @click="backStep()" icon="el-icon-arrow-left">Regresar</el-button>
              <el-button @click="nextStep()" type="primary">
                {{ $t('Siguiente') }}
                <i class="el-icon-arrow-right el-icon-right"></i>
              </el-button>
            </el-button-group>
          </el-col>
        </el-row>
        <br />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import StepsContrato from "@/components/contracts/StepsContrato.vue";
import Workflow from "@/components/workflows/Workflow2.vue";
import { Circle9 } from "vue-loading-spinner";

export default {
  name: "wizard",
  components: {
    StepsContrato,
    Workflow,
    Circle9
  },
  data() {
    return {
      loading: false,
      selectedWorkflows: {
        salud: null,
        seguridad: null,
        medioambiente: null,
      },
      auxSelectedWorkflows: {
        salud: null,
        seguridad: null,
        medioambiente: null,
      },
    };
  },
  async created() {
    if (Object.keys(this.$store.getters.newContract).length === 0) {
      this.$router.push({ name: "contractCreateStep1" });
    }
    await this.getWorkflows();
    this.selectedWorkflows.salud = this.newContract.workflows.salud;
    this.selectedWorkflows.seguridad = this.newContract.workflows.seguridad;
    this.selectedWorkflows.medioambiente = this.newContract.workflows.medioambiente;
    this.setAuxSelectedWorkflows("salud");
    this.setAuxSelectedWorkflows("seguridad");
    this.setAuxSelectedWorkflows("medioambiente");
  },
  computed: {
    ...mapGetters({
      workflows: "workflows",
      newContract: "newContract",
    }),
  },
  methods: {
    ...mapActions(["getWorkflows", "setNewContract"]),
    backStep() {
      this.$router.push({ name: "contractCreateStep1" });
    },
    async nextStep() {
      this.loading = true;
      const valid = this.workflowsValidation();
      if (valid) {
        const auxContract = Object.assign({}, this.newContract, {
          workflows: this.selectedWorkflows,
        });
        this.setNewContract(auxContract);
        this.$router.push({ name: "contractCreateStep3" });
      } else {
        this.$message({
          message:
            "Atención, Para continuar debes seleccionar un flujo de aprobación para cada tipo.",
          type: "warning",
        });
        this.loading = false;
      }
    },
    workflowsValidation() {
      if (
        this.selectedWorkflows.salud &&
        this.selectedWorkflows.seguridad &&
        this.selectedWorkflows.medioambiente
      ) {
        return true;
      }
      return false;
    },
    setAuxSelectedWorkflows(type) {
      this.auxSelectedWorkflows[type] = this.workflows.find(
        (e) => e._id === this.selectedWorkflows[type]
      );
    },
  },
};
</script>

<style scoped>
.separator {
  margin: 40px 0;
}

.worflow-preview {
  border-left: solid 1px;
  padding-left: 20px;
}

.titleProfilesArea {
  color: #606266;
  font-size: 14px;
}

.textProfilesArea {
  margin-top: 10px;
  color: gray;
  font-size: 14px;
}

.centrar {
  text-align: center;
}
</style>
